import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import style from './PositionsTable.module.css';
import { Heading4 } from '../../../atomic/text/Text';
import { colors } from '../../../../colorVars';
import { MultiSwitch } from '../../../atomic/buttons/multiSwitch/MultiSwitch';
import { OpenPositions } from './positionCollections/openPositions/OpenPositions';
import { ClosedPositions } from './positionCollections/closedPositions/ClosedPositions';
import { Executions } from './positionCollections/executions/Executions';

export const PositionsTable = observer(() => {
  const [multiSwitchValue, setMultiSwitchValue] = useState('openPositions');
  let Component;
  switch (multiSwitchValue){
    case 'openPositions':
      Component = OpenPositions;
      break;
    case 'closedPositions':
      Component = ClosedPositions;
      break;
    case 'executions':
      Component = Executions;
      break;
    default:
      Component = OpenPositions;
  }

  return (
    <div className={style.container}>
      <header className={style.header}>
        <Heading4 color={colors.lightGrey}>Positions</Heading4>
        <div className={style.buttons}>
          <MultiSwitch
            margin="0 5px 0 15px"
            labels={['Open', 'Closed', 'Executions']}
            values={['openPositions', 'closedPositions', 'executions']}
            setValue={setMultiSwitchValue}
            controlledValue={multiSwitchValue}
          />
        </div>
      </header>
      <Component />
    </div>
  );
});

